import * as Actions from "./constants";
const initialState = {
  deleteSuccess: false,
  deleteCorporateSuccess: false,
};

export default function CorporateAdminReducer(state = initialState, action) {
  switch (action.type) {
    case Actions.CREATE_CORPORATE:
      return {
        ...state,
      };
    case Actions.CREATE_CORPORATE_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    case Actions.CREATE_CORPORATE_ERROR:
      return {
        ...state,
        createError: action.error,
      };
    case Actions.CREATE_CORPORATE_ALL:
      return {
        ...state,
      };
    case Actions.CREATE_CORPORATE_ALL_SUCCESS:
      return {
        ...state,
        corporateList: action.payload,
      };
    case Actions.CREATE_CORPORATE_ALL_ERROR:
      return {
        ...state,
        error: action.error,
      };
    case Actions.DELETE_CORPORATE:
      return {
        ...state,
        deleteCorporateSuccess: false,
      }
    case Actions.DELETE_CORPORATE_SUCCESS:
      return {
        ...state,
        deleteCorporateSuccess: true,
      }
    case Actions.DELETE_CORPORATE_ERROR:
      return {
        ...state,
        deleteCorporateSuccess: false,
      }
    case Actions.EDIT_CORPORATE_PLAN:
      return {
        ...state,
      };
    case Actions.EDIT_CORPORATE_PLAN_SUCCESS:
      return {
        ...state,
        planDetails: action.payload,
      };
    case Actions.EDIT_CORPORATE_PLAN_ERROR:
      return {
        ...state,
      };
    case Actions.UPDATE_CORPORATE_PLAN:
      return {
        ...state,
      };
    case Actions.UPDATE_CORPORATE_PLAN_SUCCESS:
      return {
        ...state,
        subscription: action.payload,
      };
    case Actions.UPDATE_CORPORATE_PLAN_ERROR:
      return {
        ...state,
        createError: action.error,
      };

    default:
      return state;
  }
}
